module.exports = __webpack_public_path__ + "15454ffa796ea3a34fef35483cacb47a.pdf";